import { render, staticRenderFns } from "./RInfo.vue?vue&type=template&id=498ed52c&scoped=true&"
import script from "./RInfo.vue?vue&type=script&lang=js&"
export * from "./RInfo.vue?vue&type=script&lang=js&"
import style0 from "./RInfo.vue?vue&type=style&index=0&id=498ed52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ed52c",
  null
  
)

export default component.exports